import React from "react";
import "./publication.css";
import "./research.css";
import {Row, Col} from "react-bootstrap"

export default function ResearchInterest(){
    return(
        <div className="publicationbody">
           
            {/* <p className="publication-text"><b>Publications</b></p> */}
            <ul style={{ listStyleType: "square", fontSize: 20, color: "#f0f0f0" }}>
              <li>Field Robotics</li>
              <li>Human-Robot Interaction (HRI)</li>
              <li>Reinforcement Learning (RL)</li>
              <li>Deep Learning (DL)</li>
              <li>Autonomous Vehicle (AV)</li>
              <li>Natural Language Processing (NLP)</li>
              <li>Wireless Communication (WC)</li>
            </ul>
        <Row>

                    <Col xs={12} md={12} lg={12}>
                       
 </Col>

 </Row>
 </div>

    )}
